/**
 * 入力された値を自動変換する関数
 */
export const inputAutoChange = () => {

  /**
   * フォーカスアウトで
   * カタカナ・記号・英数字の半角を全角変換
   */
  const fullPitch = document.querySelectorAll( 'input[data-full-pitch]' ) || false;
  if ( fullPitch ) {
    fullPitch.forEach( target => {
      target.addEventListener( 'focusout', ( e ) => {
        if(e.target.value != ''){
          e.target.value = convHalfToFull( e.target.value );
        }
       } );
    } );
  }

  /**
   * フォーカスアウトで
   * ひらがなをカタカナへ変換
   * カタカナ・記号・英数字の半角を全角変換
   */
  const fullPitchKana = document.querySelectorAll( 'input[data-full-pitch-kana]' ) || false;
  if ( fullPitchKana ) {
    fullPitchKana.forEach( target => {
      target.addEventListener( 'focusout', ( e ) => {
        if(e.target.value != ''){
          e.target.value = convHalfToFull( hiraToKana( e.target.value ));
        }
       } );
    } );
  }

  /**
   * フォーカスアウトで
   * 英数字、カナの全角、一部の記号を半角へ変換
   */
    const singleNum = document.querySelectorAll( 'input[data-single-byte-num],input[data-single-byte-alphanum],input[data-regex-validation],input[data-minority-digit]' ) || false;
    if ( singleNum ) {
      singleNum.forEach( target => {
        target.addEventListener( 'focusout', ( e ) => {
          if(e.target.value != ''){
            e.target.value = convFullToHalfOfPattern1( e.target.value );
          }
         } );
      } );
    }

    /**
   * フォーカスアウトで
   * 英数字、カナの全角、記号を半角へ変換
   */
    const singleMarkalphanum = document.querySelectorAll( 'input[data-single-byte-markalphanum]' ) || false;
    if ( singleMarkalphanum ) {
      singleMarkalphanum.forEach( target => {
        target.addEventListener( 'focusout', ( e ) => {
          if(e.target.value != ''){
            e.target.value = convFullToHalfOfPattern2( e.target.value );
          }
         } );
      } );
    }

}

/** カタカナ・記号・英数字の半角を全角変換*/
function convHalfToFull(str) {
  str = str.replace(/[A-Za-z0-9,.]/g, function (s) {
    return String.fromCharCode(s.charCodeAt(0) + 65248);
  });

  var replaceFm = new Array(
    'ｶﾞ', 'ｷﾞ', 'ｸﾞ', 'ｹﾞ', 'ｺﾞ', 'ｻﾞ', 'ｼﾞ', 'ｽﾞ', 'ｾﾞ', 'ｿﾞ', 'ﾀﾞ', 'ﾁﾞ', 'ﾂﾞ', 'ﾃﾞ', 'ﾄﾞ'
    , 'ﾊﾞ', 'ﾋﾞ', 'ﾌﾞ', 'ﾍﾞ', 'ﾎﾞ', 'ﾊﾟ', 'ﾋﾟ', 'ﾌﾟ', 'ﾍﾟ', 'ﾎﾟ', 'ｳﾞ'
  );
  var replaceTo = new Array(
    'ガ', 'ギ', 'グ', 'ゲ', 'ゴ', 'ザ', 'ジ', 'ズ', 'ゼ', 'ゾ', 'ダ', 'ヂ', 'ヅ', 'デ', 'ド'
    , 'バ', 'ビ', 'ブ', 'ベ', 'ボ', 'パ', 'ピ', 'プ', 'ペ', 'ポ', 'ヴ'
  );
  for (var key in replaceFm) {
    str = str.replace(new RegExp(replaceFm[key], 'g'), replaceTo[key]);
  }
  var replaceFm = new Array(
    'ｱ', 'ｲ', 'ｳ', 'ｴ', 'ｵ', 'ｶ', 'ｷ', 'ｸ', 'ｹ', 'ｺ', 'ｻ', 'ｼ', 'ｽ', 'ｾ', 'ｿ'
    , 'ﾀ', 'ﾁ', 'ﾂ', 'ﾃ', 'ﾄ', 'ﾅ', 'ﾆ', 'ﾇ', 'ﾈ', 'ﾉ', 'ﾊ', 'ﾋ', 'ﾌ', 'ﾍ', 'ﾎ'
    , 'ﾏ', 'ﾐ', 'ﾑ', 'ﾒ', 'ﾓ', 'ﾔ', 'ﾕ', 'ﾖ'
    , 'ﾗ', 'ﾘ', 'ﾙ', 'ﾚ', 'ﾛ', 'ﾜ', 'ｦ', 'ﾝ'
    , 'ｧ', 'ｨ', 'ｩ', 'ｪ', 'ｫ', 'ｯ', 'ｬ', 'ｭ', 'ｮ'
  );
  var replaceTo = new Array(
    'ア', 'イ', 'ウ', 'エ', 'オ', 'カ', 'キ', 'ク', 'ケ', 'コ', 'サ', 'シ', 'ス', 'セ', 'ソ'
    , 'タ', 'チ', 'ツ', 'テ', 'ト', 'ナ', 'ニ', 'ヌ', 'ネ', 'ノ', 'ハ', 'ヒ', 'フ', 'ヘ', 'ホ'
    , 'マ', 'ミ', 'ム', 'メ', 'モ', 'ヤ', 'ユ', 'ヨ'
    , 'ラ', 'リ', 'ル', 'レ', 'ロ', 'ワ', 'ヲ', 'ン'
    , 'ァ', 'ィ', 'ゥ', 'ェ', 'ォ', 'ッ', 'ャ', 'ュ', 'ョ'
  );
  for (var key in replaceFm) {
    str = str.replace(new RegExp(replaceFm[key], 'g'), replaceTo[key]);
  }

  var replaceFm = new Array(
    '\\!', '"', '#', '\\$', '%', '&', '\'', '\\(', '\\)', '\\*', 
    '\\+', '-', '/', ':', ';', '<', '=', '>', '\\?', '@',
    '\\[', '\\\\', '\\]', '\\^', '\\_', '`', '\\{', '\\|', '\\}', '~', ' ', 'ｰ',
    '｢','｣','､','･','｡','ﾞ','ﾟ'
  );
  var replaceTo = new Array(
    '！', '”', '＃', '＄', '％', '＆', '’', '（', '）', '＊',
    '＋', '－', '／', '：', '；', '＜', '＝', '＞', '？', '＠',
    '［', '￥', '］', '＾', '＿', '‘', '｛', '｜', '｝', '～', '　', 'ー',
    '「', '」', '、', '・', '。', '゛', '゜'
  );
  for (var key in replaceFm) {
    str = str.replace(new RegExp(replaceFm[key], 'g'), replaceTo[key]);
  }
  return str;
};

/** ひらがなをカタカナへ変換 */
function hiraToKana(str) {
  return str.replace(/[\u3041-\u3096]/g, function(match) {
      var chr = match.charCodeAt(0) + 0x60;
      return String.fromCharCode(chr);
  });
}


/** 英数字、カナの全角、一部の記号を半角へ変換 　　*/
function convFullToHalfOfPattern1(str) {
  str = str.replace(/[Ａ-Ｚａ-ｚ０-９，．]/g, function (s) {
    return String.fromCharCode(s.charCodeAt(0) - 65248);
  });
  var replaceFm = new Array(
    'ガ', 'ギ', 'グ', 'ゲ', 'ゴ', 'ザ', 'ジ', 'ズ', 'ゼ', 'ゾ', 'ダ', 'ヂ', 'ヅ', 'デ', 'ド'
    , 'バ', 'ビ', 'ブ', 'ベ', 'ボ', 'パ', 'ピ', 'プ', 'ペ', 'ポ', 'ヴ'
  );
  var replaceTo = new Array(
    'ｶﾞ', 'ｷﾞ', 'ｸﾞ', 'ｹﾞ', 'ｺﾞ', 'ｻﾞ', 'ｼﾞ', 'ｽﾞ', 'ｾﾞ', 'ｿﾞ', 'ﾀﾞ', 'ﾁﾞ', 'ﾂﾞ', 'ﾃﾞ', 'ﾄﾞ'
    , 'ﾊﾞ', 'ﾋﾞ', 'ﾌﾞ', 'ﾍﾞ', 'ﾎﾞ', 'ﾊﾟ', 'ﾋﾟ', 'ﾌﾟ', 'ﾍﾟ', 'ﾎﾟ', 'ｳﾞ'
  );
  for (var key in replaceFm) {
    str = str.replace(new RegExp(replaceFm[key], 'g'), replaceTo[key]);
  }
  var replaceFm = new Array(
    'ア', 'イ', 'ウ', 'エ', 'オ', 'カ', 'キ', 'ク', 'ケ', 'コ', 'サ', 'シ', 'ス', 'セ', 'ソ'
    , 'タ', 'チ', 'ツ', 'テ', 'ト', 'ナ', 'ニ', 'ヌ', 'ネ', 'ノ', 'ハ', 'ヒ', 'フ', 'ヘ', 'ホ'
    , 'マ', 'ミ', 'ム', 'メ', 'モ', 'ヤ', 'ユ', 'ヨ'
    , 'ラ', 'リ', 'ル', 'レ', 'ロ', 'ワ', 'ヲ', 'ン'
    , 'ァ', 'ィ', 'ゥ', 'ェ', 'ォ', 'ッ', 'ャ', 'ュ', 'ョ', '　', '‐'
    , '＠', '（', '）',
  );
  var replaceTo = new Array(
    'ｱ', 'ｲ', 'ｳ', 'ｴ', 'ｵ', 'ｶ', 'ｷ', 'ｸ', 'ｹ', 'ｺ', 'ｻ', 'ｼ', 'ｽ', 'ｾ', 'ｿ'
    , 'ﾀ', 'ﾁ', 'ﾂ', 'ﾃ', 'ﾄ', 'ﾅ', 'ﾆ', 'ﾇ', 'ﾈ', 'ﾉ', 'ﾊ', 'ﾋ', 'ﾌ', 'ﾍ', 'ﾎ'
    , 'ﾏ', 'ﾐ', 'ﾑ', 'ﾒ', 'ﾓ', 'ﾔ', 'ﾕ', 'ﾖ'
    , 'ﾗ', 'ﾘ', 'ﾙ', 'ﾚ', 'ﾛ', 'ﾜ', 'ｦ', 'ﾝ'
    , 'ｧ', 'ｨ', 'ｩ', 'ｪ', 'ｫ', 'ｯ', 'ｬ', 'ｭ', 'ｮ', ' ', '-'
    , '@', '(', ')',
  );
  for (var key in replaceFm) {
    str = str.replace(new RegExp(replaceFm[key], 'g'), replaceTo[key]);
  }
  return str;

}


/** 英数字、カナの全角、記号を半角へ変換 　　*/
function convFullToHalfOfPattern2(str) {
  str = str.replace(/[Ａ-Ｚａ-ｚ０-９，．]/g, function (s) {
    return String.fromCharCode(s.charCodeAt(0) - 65248);
  });
  var replaceFm = new Array(
    'ガ', 'ギ', 'グ', 'ゲ', 'ゴ', 'ザ', 'ジ', 'ズ', 'ゼ', 'ゾ', 'ダ', 'ヂ', 'ヅ', 'デ', 'ド'
    , 'バ', 'ビ', 'ブ', 'ベ', 'ボ', 'パ', 'ピ', 'プ', 'ペ', 'ポ', 'ヴ'
  );
  var replaceTo = new Array(
    'ｶﾞ', 'ｷﾞ', 'ｸﾞ', 'ｹﾞ', 'ｺﾞ', 'ｻﾞ', 'ｼﾞ', 'ｽﾞ', 'ｾﾞ', 'ｿﾞ', 'ﾀﾞ', 'ﾁﾞ', 'ﾂﾞ', 'ﾃﾞ', 'ﾄﾞ'
    , 'ﾊﾞ', 'ﾋﾞ', 'ﾌﾞ', 'ﾍﾞ', 'ﾎﾞ', 'ﾊﾟ', 'ﾋﾟ', 'ﾌﾟ', 'ﾍﾟ', 'ﾎﾟ', 'ｳﾞ'
  );
  for (var key in replaceFm) {
    str = str.replace(new RegExp(replaceFm[key], 'g'), replaceTo[key]);
  }
  var replaceFm = new Array(
    'ア', 'イ', 'ウ', 'エ', 'オ', 'カ', 'キ', 'ク', 'ケ', 'コ', 'サ', 'シ', 'ス', 'セ', 'ソ'
    , 'タ', 'チ', 'ツ', 'テ', 'ト', 'ナ', 'ニ', 'ヌ', 'ネ', 'ノ', 'ハ', 'ヒ', 'フ', 'ヘ', 'ホ'
    , 'マ', 'ミ', 'ム', 'メ', 'モ', 'ヤ', 'ユ', 'ヨ'
    , 'ラ', 'リ', 'ル', 'レ', 'ロ', 'ワ', 'ヲ', 'ン'
    , 'ァ', 'ィ', 'ゥ', 'ェ', 'ォ', 'ッ', 'ャ', 'ュ', 'ョ'
  );
  var replaceTo = new Array(
    'ｱ', 'ｲ', 'ｳ', 'ｴ', 'ｵ', 'ｶ', 'ｷ', 'ｸ', 'ｹ', 'ｺ', 'ｻ', 'ｼ', 'ｽ', 'ｾ', 'ｿ'
    , 'ﾀ', 'ﾁ', 'ﾂ', 'ﾃ', 'ﾄ', 'ﾅ', 'ﾆ', 'ﾇ', 'ﾈ', 'ﾉ', 'ﾊ', 'ﾋ', 'ﾌ', 'ﾍ', 'ﾎ'
    , 'ﾏ', 'ﾐ', 'ﾑ', 'ﾒ', 'ﾓ', 'ﾔ', 'ﾕ', 'ﾖ'
    , 'ﾗ', 'ﾘ', 'ﾙ', 'ﾚ', 'ﾛ', 'ﾜ', 'ｦ', 'ﾝ'
    , 'ｧ', 'ｨ', 'ｩ', 'ｪ', 'ｫ', 'ｯ', 'ｬ', 'ｭ', 'ｮ'
  );
  for (var key in replaceFm) {
    str = str.replace(new RegExp(replaceFm[key], 'g'), replaceTo[key]);
  }

  var replaceFm = new Array(
    '！', '”', '＃', '＄', '％', '＆', '’', '（', '）', '＊',
    '＋', '－', '／', '：', '；', '＜', '＝', '＞', '？', '＠',
    '［', '￥', '］', '＾', '＿', '‘', '｛', '｜', '｝', '～', '　', 'ー', '‐', '―',
    '「', '」', '、', '・', '。', '゛', '゜'

  );
  var replaceTo = new Array(
    '!', '"', '#', '$', '%', '&', '\'', '(', ')', '*', 
    '+', '-', '/', ':', ';', '<', '=', '>', '?', '@',
    '[', '\\', ']', '^', '_', '`', '{', '|', '}', '~', ' ', 'ｰ', '-', '-',
    '｢','｣','､','･','｡','ﾞ','ﾟ'

  );
  for (var key in replaceFm) {
    str = str.replace(new RegExp(replaceFm[key], 'g'), replaceTo[key]);
  }
  return str;

}





